import { createSelector } from 'reselect'

const getState = state => state.Examples

const getFetchExamplesRequest = state => getState(state).fetchExamplesRequest

const getExamples = state => getState(state).examples

const getExamplesResult = createSelector(
  [getExamples],
  examples => (!examples ? [] : examples.result)
)

const getExamplesMap = createSelector(
  [getExamples],
  examples => (!examples ? {} : examples.entities.examples)
)

const getExamplesList = createSelector(
  [getExamplesResult, getExamplesMap],
  (result, examplesMap) => result.map(id => examplesMap[id])
)

const getExample = (state, id) => getExamplesMap(state)[id]

const getSchoolOrganisationFilter = state =>
  getState(state).filters.schoolOrganisation

export {
  getExamples,
  getExamplesList,
  getFetchExamplesRequest,
  getExample,
  getSchoolOrganisationFilter
}
